<svelte:head>

    <title>Reviews • keyosh</title>

</svelte:head>

<script>

    import SessionManager from "../components/utils/session.svelte";
    import Reviews from "../components/reviews.svelte";

</script>

<SessionManager />

<section>

    <Reviews/>

</section>


<style>

    section {
        height: inherit;
    }

</style>
